/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 23/11/2023 | Lic. José Luis Aragón Cervantes  | Creación
*      2       | 03/06/2026 | Lic. José Luis Aragón Cervantes  | Se agregan APIs de laboratorio para plantillas de ticket
*      3       | 22/06/2026 | Lic. José Luis Aragón Cervantes  | Se agregan prefijos Tenant a todas las rutas
 *      4       | 15/07/2026 | Lic. José Luis Aragón Cervantes  | Se agregan APIs de solicitudes de acceso para dispositivos móviles
 *      5       | 18/09/2026 | Lic. José Luis Aragón Cervantes  | API reporte entradas/salidas por periodo
 *      6       | 23/09/2026 | LIC. José Luis Aragón C.                               | APIs catálogo cbarras Redis + buffer
 *              |            |                                          | de captura entradas/salidas
 *      7       | 23/09/2026 | LIC. José Luis Aragón C.                               | APIs traslados Redis + buscador
 *      8       | 23/09/2026 | LIC. José Luis Aragón C.                       | Ortografía: caracteres reparados a UTF-8
 *      9       | 25/09/2026 | LIC. José Luis Aragón C.                       | Reporte traslados por periodo (mismo decorador)
 * ---------------------------------------------------------------------------------------
*/

//Servicio de autentificación y adquisición de token de autorización de consumo de servicios
export const serverSeguridad = process.env.REACT_APP_ServerSeguridad;
export const serverSubprocess = process.env.REACT_APP_ServerSubProcess;
export const serverAdministrativo = process.env.REACT_APP_ServerAdministrativo;
export const serverCatalogos = process.env.REACT_APP_ServerCatalogos;
export const serverTomaInventarios = process.env.REACT_APP_ServerTomaInventarios; 
export const serverIA = process.env.REACT_APP_ServerIA;
export const serverCentroCostos = process.env.REACT_APP_ServerCentroCostos;
export const serverClientesMoviles = process.env.REACT_APP_ServerClientesMoviles;

//Apis del sistema

//Accesos
export const apiMenusListaUsuario =
  serverSubprocess + "/TenantSubProcessAccesos/menususuariolist/{idusuario}"; //Funcionalidad para devolver la lista de menús asignados al usuario dentro del sistema
export const apiAccesosList = serverSubprocess + "/TenantSubProcessAccesos/accesoslist"; //Funcionalidad para obtener la lista de accesos al sistema

export const apiAccesosGuardar = serverCatalogos + "/TenantCatalogoAccesos/guardar"; //Funcionalidad para actualizar los datos de un acceso existente
export const apiMenusGuardarUsuario =
  serverCatalogos + "/TenantCatalogoAccesos/guardarmenus"; //Funcionalidad para guardar los menús asignados a un usuario
export const apiPermisosGuardarUsuario =
  serverCatalogos + "/TenantCatalogoAccesos/guardarpermisos"; //Funcionalidad para guardar los permisos asignados a un usuario
export const apiAlcancesGuardarUsuario =
  serverCatalogos + "/TenantCatalogoAccesos/guardaralcances";
export const apiAccesosDelete =
  serverCatalogos + "/TenantCatalogoAccesos/delete/{idusuario}"; //Funcionalidad para eliminar un acceso existente

export const apiAccesosData = serverSubprocess + "/TenantSubProcessAccesos/getdata/{idusuario}"; //Funcionalidad para obtener los datos completos de un acceso en particular
export const apiAccesosMenus =
  serverSubprocess + "/TenantSubProcessAccesos/getmenus/{idusuario}"; //Funcionalidad para obtener los menús asignados a un acceso
export const apiAccesosPermisos =
  serverSubprocess + "/TenantSubProcessAccesos/getpermisos/{idusuario}"; //Funcionalidad para obtener los permisos asignados a un acceso
export const apiAccesosAlcances =
  serverSubprocess + "/TenantSubProcessAccesos/getalcances/{idusuario}"; //Funcionalidad para obtener los alcances asignados a un acceso

//login de acceso al sistema
export const apiLogin = serverSeguridad + "/TenantSeguridad/login";
export const apiLoginRefresh = serverSeguridad + "/TenantSeguridad/RefreshToken";
export const apiPostMenuModelUser =
  serverSeguridad + "/TenantSeguridad/menumodel/{idUser}";
export const apiCambiarPasswordInicial =
  serverSeguridad + "/TenantSeguridad/CambiarPasswordInicial";
export const apiLoginValidator = serverSubprocess + "/TenantSubProcessSeguridad/loginvalidator";

//Activacion tenant ARSync
export const apiTenantDeviceValidate = serverSeguridad + "/TenantDevice/validate";
export const apiTenantMobileDeviceValidate = serverSeguridad + "/TenantMobileActivation/validate";
export const apiTenantDeviceFindByName = serverSeguridad + "/TenantDevice/find-by-name";
export const apiTenantDeviceReassign = serverSeguridad + "/TenantDevice/reassign";
export const apiTenantDeviceDatabaseName = serverSeguridad + "/TenantDevice/database-name";
export const apiTenantDeviceListByHardware = serverSeguridad + "/TenantDevice/list-by-hardware";
export const apiTenantActivationRedeem = serverSeguridad + "/TenantActivation/redeem";
export const apiTenantMobileActivationRedeem = serverSeguridad + "/TenantMobileActivation/redeem";
export const apiTenantMobileChallengeSend = serverSeguridad + "/TenantMobileActivation/challenge/send";
export const apiTenantMobileChallengeConfirm = serverSeguridad + "/TenantMobileActivation/challenge/confirm";
export const apiTenantMobileDeviceRecover = serverSeguridad + "/TenantAdmin/mobile/recover";
export const apiTenantMobileDeviceAccessRequest = serverSeguridad + "/TenantMobileDeviceAccess/request";
export const apiTenantMobileDeviceAccessList = serverSeguridad + "/TenantMobileDeviceAccess/admin/list";
export const apiTenantMobileDeviceAccessApprove = serverSeguridad + "/TenantMobileDeviceAccess/admin/approve";
export const apiTenantMobileDeviceAccessRevoke = serverSeguridad + "/TenantMobileDeviceAccess/admin/revoke";
export const apiTenantMobileDeviceAccessDelete = serverSeguridad + "/TenantMobileDeviceAccess/admin/delete";
export const apiTenantProvisioningRun = serverSeguridad + "/TenantActivation/provisioning/run";
export const apiTenantAdminLogin = serverSeguridad + "/TenantAdmin/dashboard/login";
export const apiTenantAdminPasswordRecoverMfa = serverSeguridad + "/TenantAdmin/password/recover/mfa";
export const apiTenantAdminPasswordRecoverLinkRequest = serverSeguridad + "/TenantAdmin/password/recover/link/request";
export const apiTenantAdminPasswordRecoverLinkConfirm = serverSeguridad + "/TenantAdmin/password/recover/link/confirm";
export const apiTenantMfaSetup = serverSeguridad + "/TenantAdmin/pre-register";
export const apiTenantMfaConfirm = serverSeguridad + "/TenantAdmin/mfa/confirm";
export const apiTenantPrinterToolsDownload = serverSeguridad + "/TenantDownloads/printertools";
export const apiTenantLocalDeviceLicense = "http://localhost:4000/api/tenant/device-license";
export const apiTenantLocalDeviceValidate = "http://localhost:4000/api/tenant/device/validate";
export const apiTenantLocalFingerprint = "http://localhost:4000/api/tenant/fingerprint";
export const apiTenantComunicacionListar = serverSeguridad + "/TenantComunicacion/listar";
export const apiTenantComunicacionGuardar = serverSeguridad + "/TenantComunicacion/guardar";
export const apiTenantComunicacionObtener = serverSeguridad + "/TenantComunicacion/obtener";
export const apiTenantComunicacionConsumir = serverSeguridad + "/TenantComunicacion/consumir";

//Tickets de soporte Tenant <-> Support (canal tenant, BD maestra)
export const apiSoporteTickets = serverSeguridad + "/TenantTickets";
export const apiSoporteMisTickets = serverSeguridad + "/TenantTickets/mistickets";
export const apiSoporteTicketDetalle = (id) => serverSeguridad + `/TenantTickets/${id}`;
export const apiSoporteTicketResponder = (id) => serverSeguridad + `/TenantTickets/${id}/responder`;
export const apiSoporteTicketLeer = (id) => serverSeguridad + `/TenantTickets/${id}/leer`;
export const apiSoporteTicketAdjunto = (id, adjuntoId) => serverSeguridad + `/TenantTickets/${id}/adjuntos/${adjuntoId}`;

//Control de folios
export const apiVentasFolio =
  serverSubprocess + "/TenantSubProcess/folioventa/{idCaja}";
export const apiCotizacionesFolio =
  serverSubprocess + "/TenantSubProcess/foliocotizacion/{idCaja}";
export const apiApartadosFolio =
  serverSubprocess + "/TenantSubProcess/folioapartados/{idCaja}";
export const apiPreventasFolio =
  serverSubprocess + "/TenantSubProcess/foliopreventa/{idCaja}";
export const apiIncrementaVentasFolio =
  serverSubprocess + "/TenantSubProcess/incrementafolioventa/{caja}";
export const apiIncrementaCotizacionesFolio =
  serverSubprocess + "/TenantSubProcess/incrementafoliocotizacion/{idCaja}";
export const apiIncrementaApartadosFolio =
  serverSubprocess + "/TenantSubProcess/incrementafolioapartados/{idCaja}";
export const apiIncrementaPreventasFolio =
  serverSubprocess + "/TenantSubProcess/incrementafoliopreventa/{idCaja}";

//Catálogos
export const apiBuscarArticuloPorCodigoBarras =
  serverSubprocess + "/TenantSubProcess/articulo/{codigobarras}";
export const apiBuscarArticuloPorClaveMedida =
  serverSubprocess + "/TenantSubProcess/articulo/{clavearticulo}/{medida}"; //Funcionalidad empleada para buscar datos completos de artículos por clave y medida
export const apiBuscarArticuloPorClave =
  serverSubprocess + "/TenantSubProcess/articulofulldata//{clavearticulo}"; //Funcionalidad empleada para buscar datos completos de artículos por clave
export const apiAsistenciaPisoArticulo =
  serverIA + "/TenantIAArticulos/articulo/{clavearticulo}"; //Funcionalidad empleada por Asistencia en piso
export const apiCargarArticuloPorClave =
  serverSubprocess + "/TenantArticulos/articulomedidas/{clavearticulo}"; //Funcionalidad empleada para buscar datos completos de artículos por clave
export const apiBuscarClientePorNombre =
  serverSubprocess + "/TenantClientes/clientesnombre/{nombre}";
export const apiBuscarClientePorClave = serverCatalogos + "/TenantCatalogoClientes/clientesclave/{clave}";
export const apiBuscararticulosFiltroFull =
  serverSubprocess +
  "/TenantArticulos/buscararticulosfull/{busqueda}/{registroinicial}/{totalregistros}"; //Funconalidad para obtener una entidad con datos para uso de la herramienta de filtración
export const apiBuscararAlmacenesOcurrencias =
  serverSubprocess + "/TenantArticulos/buscarocurrencias/{clavearticulo}"; //Funconalidad para obtener los almacenes y sus existencias en medidas de un artículo
export const apiListaAlmacenesExhibidores =
  serverSubprocess + "/TenantSubProcess/almacenesexhibidoreslist"; //Funcionalidad para obtener la lista de almacenesexhibidores del sistema
export const apiAlmacenesExhibidoresList =
  serverCatalogos + "/TenantCatalogoAlmacenesExhibidores/almacenesexhibidoreslist"; //Funcionalidad para obtener la lista del catálogo
export const apiAlmacenesExhibidoresSave =
  serverCatalogos + "/TenantCatalogoAlmacenesExhibidores/almacenesexhibidoresave"; //Funcionalidad para guardar o actualizar un almacén exhibidor
export const apiAlmacenesExhibidoresDelete =
  serverCatalogos + "/TenantCatalogoAlmacenesExhibidores/almacenesexhibidoresdelete/{nombre}"; //Funcionalidad para eliminar un almacén exhibidor del sistema
export const apiListaCorridas =
  serverCatalogos + "/TenantCatalogoCorridas/corridaslist"; //Funcionalidad para obtener la lista de Corridas (tallas) del sistema
export const apiCorridasSave =
  serverCatalogos + "/TenantCatalogoCorridas/corridassave"; //Funcionalidad para guardar o actualizar una Corrida
export const apiCorridasDelete =
  serverCatalogos + "/TenantCatalogoCorridas/corridasdelete/{descripcion}"; //Funcionalidad para eliminar una Corrida del sistema
export const apiCorridasDeleteAll =
  serverCatalogos + "/TenantCatalogoCorridas/corridasdeleteall"; //Funcionalidad para eliminar todas las Corridas del sistema
export const apiListasCatalogosArticulos =
  serverSubprocess + "/TenantSubProcess/catalogosarticulos"; //Funcionalidad para obtener las listas de los catálogos útiles en el módulo de catálogos
export const apiArticuloSave =
  serverCatalogos + "/TenantCatalogoArticulos/articulosave"; //Funcionalidad para registrar y actualizar artículos en sistema.
export const apiCatalogosGuardarImagen =
  serverCatalogos + "/TenantCatalogoArticulos/guardarimagen"; //Funcionalidad para guardar solo la imagen de un artículo en Catálogos.
export const apiCodigobarrasSave =
  serverCatalogos +
  "/TenantCatalogoArticulos/codigobarrasssave/{clavearticulo}/{medida}/{codigobarras}"; //Funcionalidad para actualizar el código de barras de las medidas.
export const apiMedidasSave =
  serverCatalogos + "/TenantCatalogoArticulos/medidassave"; //Funcionalidad para registrar y actualizar medidas de artículo del sistema.
export const apiObtenerCorridas =
  serverSubprocess + "/TenantArticulos/obtenercorridas"; //Funcionalidad para obtener la lista de corridas del sistema.
export const apiArticuloDeleteFullData =
  serverCatalogos + "/TenantCatalogoArticulos/eliminararticulo/{clavearticulo}"; //Funcionalidad para eliminar toda la información de un artículo del sistema.
export const apiArticuloDeleteMedidaFullData =
  serverCatalogos +
  "/TenantCatalogoArticulos/eliminarmedida/{clavearticulo}/{medida}"; //Funcionalidad para eliminar toda la información de una medida del artículo del sistema.
export const apiEliminarTodasMedidasArticulo =
  serverCatalogos +
  "/TenantCatalogoArticulos/eliminartodasmedidas/{clavearticulo}"; //Funcionalidad para eliminar todas las medidas de un artículo del sistema.
export const apiProveedoresPorArticulo =
  serverSubprocess + "/TenantArticulos/articulofabricantes/{clavearticulo}"; //Funcionalidad para obtener la lista de fabricantes con estatus de asignación por artículo.
export const apiMedidasList =
  serverSubprocess + "/TenantArticulos/medidaslist/{clavearticulo}"; //Funcionalidad para obtener la lista de meddidas por articulo y sus detalles.

export const apiAccesosListPortable =
  serverSubprocess + "/TenantSubProcessAccesos/getaccesoslistmobile"; //Funcionalidad para obtener la lista de accesos del sistema.

//Configuración
export const apiParametrosCaja =
  serverSubprocess + "/TenantSubProcess/parametroscaja/{idCaja}"; //Funcionalidad para obtener los parametros generales de3 una estación de trabajo solo entradas y salidas se manejan en Parametros
export const apiSaveParametrosCaja =
  serverSubprocess + "/TenantSubProcess/updateparametroscaja"; //Funcionalidad para actualizar los parametros generales de una estación
export const apiListaEquiposSistema =
  serverSubprocess + "/TenantSubProcess/listaequipos"; //Funcionalidad para obtener la lista de equipos registrados en sistema
export const apiParametrosTicket =
  serverSubprocess + "/TenantSubProcess/parametrosticket/{idCaja}/{tipoTicket}"; //Funcionalidad para obtener plantilla personalizada de ticket por caja
export const apiSaveParametrosTicket =
  serverSubprocess + "/TenantSubProcess/saveparametrosticket"; //Funcionalidad para guardar plantilla personalizada de ticket por caja
export const apiParametrosGet =
  serverSubprocess + "/TenantSubProcess/parametro/{nombre}"; //Funcionalidad para obtener un parámetro genérico de la tabla Parametros (ej. esquema de bonos de nómina)
export const apiParametrosSave =
  serverSubprocess + "/TenantSubProcess/parametro"; //Funcionalidad para guardar o actualizar un parámetro genérico de la tabla Parametros (ej. esquema de bonos de nómina)
export const apiCompuValidator =
  serverSubprocess + "/TenantSubProcess/compuvalidator/{id}/{pc}"; //Funcionalidad para para validar el nombre de registro de la computadora en el sistema

//Ventas
export const apiVentasList = serverSubprocess + "/TenantVentas/list";
export const apiRegistrarArticuloPorEscaneo = serverSubprocess + "/TenantVentas/registrararticulo"; //Se usa para, preventas, cotizaciones y apartados
export const apiRegistrarArticuloVenta = serverSubprocess + "/TenantVentas/registrararticuloventa"; //Solo para Venta Super - fuerza registro en Remision_Temporal
export const apiRegistrarEscaneosFromList = serverSubprocess + "/TenantVentas/registrararticulofromlist"; //Se usa para registrar artículos desde listas txt de escaneos
export const apiEliminarPartida = serverSubprocess + "/TenantVentas/eliminapartida/{remision}/{pc}/{idpartida}/{tipoventa}/{usuariopreventa}"; //Se usa para eliminar una partida viva de una venta
export const apiEliminarVenta = serverSubprocess + "/TenantVentas/eliminaventa/{remision}/{pc}/{tipoventa}"; //Se usa para eliminar una venta completa sin terminar
export const apiEliminarVentaYApartados = serverSubprocess + "/TenantVentas/eliminaventaypreventa/{Remision}/{PC}"; //Se usa para eliminar una venta completa sin terminar justo con sus preventas cargadas
export const apiSumarPartidaVenta = serverSubprocess + "/TenantVentas/sumarpartida"; //Se usa para sumar piezas a una partida ya registrada
export const apiRestarPartidaVenta = serverSubprocess + "/TenantVentas/restarpartida"; //Se usa para sumar piezas a una partida ya registrada
export const apiTerminarVenta = serverSubprocess + "/TenantVentas/terminarventa"; //Se usa para terminar el proceso de venta y desgloses de inventarios
export const apiTerminarCotizacion = serverSubprocess + "/TenantVentas/terminarcotizacion"; //Se usa para guardar la venta actual como cotización
export const apiAplicaDescuentoAClienteVenta = serverSubprocess + "/TenantVentas/descuentoventa/{remision}/{pc}/{clavecliente}/{razonsocial}/{porcentaje}"; //Se usa para aplicar el porcentaje de descuentos configurado para el cliente a la venta
export const apiObtenerRemisionVenta = serverSubprocess + "/TenantVentas/obtenerremisionventacaja/{remision}/{caja}"; //Se usa para obtener los datos de la venta en una caja especifica para impresión o consulta
export const apiObtenerCotizacionImpresion = serverSubprocess + "/TenantVentas/obtenercotizacion/{folioCotizacion}/{pc}"; //Se usa para obtener los datos de una cotización para reimpresión
export const apiValidarCostosDescuento = serverSubprocess + "/TenantVentas/validardescuento/{clavearticulo}/{medida}/{costo}"; //Funcionalidad para validar costos de descuento por artículos
export const apiAplicarDescuentosVentas = serverSubprocess + "/TenantVentas/aplicardescuentosventa"; //Funcionalidad para aplicar descuentos capturadoe desde la ventana de descuentas en ventas
export const apiRecalcularCostosClienteVenta = serverSubprocess + "/TenantVentas/recalcularcostoscliente"; //Se usa para recalcular costos de partidas vivas al cargar cliente
export const apiCorteCaja = serverSubprocess + "/TenantVentas/cortecaja"; //Funcionalidad para realizar cortes de caja y retiros
export const apiVentasDia = serverSubprocess + "/TenantAdministracion/ventascaja/{fechaventa}/{pc}/{vendedor}"; //Funcionalidad para obtener los datos de ventas de una caja por fecha
export const apiListadoVentasCaja = serverSubprocess + "/TenantAdministracion/listadoventas/{pc}"; //Funcionalidad para obtener el listado de ventas por rango de fechas y caja
export const apiListaCajasRegistro = serverSubprocess + "/TenantAdministracion/listacajas"; //Funcionalidad para obtener la lista de cajas de registro del sistema
export const apiListaFiltroVentasCaja = serverSubprocess + "/TenantVentas/ventacajafiltrolist"; //Funcionalidad para filtración de las ventas por caja usando fecha, medida y descripción
export const apiAplicarDevolucionCaja = serverSubprocess + "/TenantVentas/aplicardevolucion"; //Funcionalidad para aplicar la devolución por caja
export const apiVentasPeriodoAlmacen = serverSubprocess + "/TenantVentas/ventasperiodoalmacen/{fechainicio}/{fechafin}/{almacenexhibidor}/{filtro}"; //Funcionalida para obtener las cantidades y reporte de artículos vendidos almacen/exhibidor, con filtro de descripción o clave de artículo
export const apiEliminarVentaFull = serverSubprocess + "/TenantVentas/eliminavetafull"; //Eliminar venta completa con sus preventas asociadas
export const apiLimpiarPreventas = serverSubprocess + "/TenantVentas/limpiarpreventas"; //Limpiar todas las preventas de Remision_Temporal_Portatil
export const apiLimpiarPreventasPortatil = serverSubprocess + "/TenantVentas/limpiarpreventasportatil"; //Limpiar preventas específicas de Remision_Temporal_Portatil por vendedorpreventa y foliopreventa

//Apartados
export const apiRegistrarApartadoList = serverSubprocess + "/TenantApartados/registrarapartados"; //Funcionalidad para registrar los artículos a apartados mediante lista
export const apiConceptosYGruposList =
  serverSubprocess + "/TenantApartados/listaconceptosygruposapartados"; //Funcionalidad para obtener una lista agrupada de conceptos y sus grupos
export const apiBuscarApartadosList =
  serverSubprocess + "/TenantApartados/filtroapartadoslist"; //Funcionalidad para filtrar y obtener una lista de apartados
export const apiBuscarEstadoCuenteClienteApartados =
  serverSubprocess +
  "/TenantApartados/estadocuentaclienteapartados/{nombrecliente}/{folioapartado}/{partida}"; //Funcionalidad que obtiene el estado de cuenta de los clientes de apartados
export const apiRegistrarAbonoApartado = serverSubprocess + "/TenantApartados/registrarabono"; //Funcionalidad para registrar abono a un apartado
export const apiCambiarCostoArticuloApartado =
  serverSubprocess + "/TenantApartados/cambiocostoarticulopartida"; //Funcionalidad para cambio de costo de un artículo en un apartado
export const apiCancelarApartado =
  serverSubprocess + "/TenantApartados/cancelarapartado"; //Funcionalidad para terminar un apartado y dar entrega de mercancia con conclusion de apartado
export const apiEntregaDefinitivaApartado =
  serverSubprocess + "/TenantApartados/entregadefinitiva"; //Funcionalidad para entrega definitiva de un apartado
export const apiTerminarApartado =
  serverSubprocess + "/TenantApartados/terminarapartado"; //Funcionalidad para cambiar status de apartado a ENTREGADO
export const apiMantenimientoCuentasApartados =
  serverSubprocess + "/TenantApartados/mantenimientocuentas"; //Funcionalidad para mantenimiento de cuentas de apartados por caducidad

//Creditos clientes
// Bitacora: 20/07/2026 | Lic. Jose Luis Aragon Cervantes | Endpoints base para control puntual de creditos a clientes
export const apiCreditoClientesEstadoCuenta =
  serverAdministrativo + "/TenantCreditoClientes/estadocuenta/{clavecliente}";
export const apiCreditoClientesRegistrarAbono =
  serverAdministrativo + "/TenantCreditoClientes/registrarabono";
export const apiCreditoClientesRegistrarNotaCredito =
  serverAdministrativo + "/TenantCreditoClientes/registrarnotacredito";
export const apiCreditoClientesReimprimirAbono =
  serverAdministrativo + "/TenantCreditoClientes/abono/{folioabono}";
export const apiCreditoClientesMigrarVenta =
  serverAdministrativo + "/TenantCreditoClientes/migrarventacredito";
export const apiCreditoClientesList =
  serverAdministrativo + "/TenantCreditoClientes/list";

//Preventas
export const apiObtenerPreventa =
  serverSubprocess +
  "/TenantVentas/obtenerpreventacaja/{foliopreventa}/{usuariopreventa}/{caja}"; //Se usa para obtener los datos de la venta en una caja especifica para impresión o consulta
export const apiFirmarPreventa = serverSubprocess + "/TenantVentas/firmarpreventa"; //Se usa para obtener los datos de la venta en una caja especifica para impresión o consulta
export const apiObtenerListaPreventas =
  serverSubprocess + "/TenantVentas/obtenerpreventas"; //Funcionalidad que devuelve la lista de preventas disponibles para vista al jalar para ventas
export const apiObtenerListaCotizaciones =
  serverSubprocess + "/TenantVentas/buscarcotizaciones/{caja}"; //Funcionalidad que devuelve la lista de cotizaciones por caja y fechas
export const apiRecuperarListaPreventas =
  serverSubprocess + "/TenantVentas/recuperarpreventas/{vendedor}/{pc}"; //Funcionalidad que devuelve la lista de preventas de un vendedor
export const apiTransferirPreventaCaja =
  serverSubprocess + "/TenantVentas/transferirpreventa/{vendedor}/{pcOrigen}/{folioPreventa}/{pcDestino}"; //Funcionalidad que mueve una preventa a la caja destino con folio disponible
export const apiInyectarPreventaAVenta =
  serverSubprocess +
  "/TenantVentas/importarpreventaaventa/{remision}/{pc}/{foliopreventa}/{vendedorpreventa}"; //Funcionalidad que inyecta una preventa en particular disponible ha la venta actual
export const apiInyectarCotizacionAVenta =
  serverSubprocess +
  "/TenantVentas/importarcotizaciontaaventa/{remision}/{pc}/{remisioncotizacion}/{vendedorcotizacion}"; //Funcionalidad que inyecta una cotización en particular disponible ha la venta actual

//Inventarios
export const apiAplicarEntradaSalidaInventario =
  serverSubprocess +
  "/TenantMovimientosInventarios/aplicarentradasalida/{folio}/{tipo}/{caja}"; //Funcionalidad para aplicar una entrada o salida ya registrada en estatus de Captura("CA") al inventario
export const apiRegistrarArticuloSalidaInventario =
  serverSubprocess + "/TenantMovimientosInventarios/registrararticulosalida"; //Funcionalidad para registro de artículos a salidas del inventario
export const apiRegistrarArticuloEntradaInventario =
  serverSubprocess + "/TenantMovimientosInventarios/registrararticuloentrada"; //Funcionalidad para registro de artículos a entradas del inventario
export const apiIncrementarFolioSalidas =
  serverSubprocess + "/TenantMovimientosInventarios/incrementarfoliosalida/{pc}"; //Funcionalidad para incrementar el folio consecutivo de salidas del inventario
export const apiIncrementarFolioEntradas =
  serverSubprocess + "/TenantMovimientosInventarios/incrementarfolioentrada/{pc}"; //Funcionalidad para incrementar el folio consecutivo de entradas del inventario
export const apiFolioDisponibleSalidas =
  serverSubprocess + "/TenantMovimientosInventarios/foliosalida/{pc}"; //Funcionalidad para obtener el folio de salidas disponible por equipo
export const apiFolioDisponibleEntradas =
  serverSubprocess + "/TenantMovimientosInventarios/folioentrada/{pc}"; //Funcionalidad para obtener el folio de entradas disponible por equipó
export const apiObtenerEntradasSalidas =
  serverSubprocess +
  "/TenantMovimientosInventarios/entradasalidaget/{folioentradasalida}/{tipo}/{pc}"; //Funcionalidad para obtener entradas o salidas y sus detalles
export const apiObtenerListaAgrupadaEntradasSalidas =
  serverSubprocess +
  "/TenantMovimientosInventarios/listaentradassalidas/{tipo}/{status}"; //Funcionalidad para obtener una lista de Entradas/Salidas por estatus agrupadas para combos

export const apiObtenerListaConceptosEntradas = serverSubprocess + "/TenantMovimientosInventarios/listaconceptosentradas"; //Funcionalidad para obtener una lista de Conceptos de Entradas/Salidas para combos
export const apiObtenerListaConceptosSalidas = serverSubprocess + "/TenantMovimientosInventarios/listaconceptossalidas"; //Funcionalidad para obtener una lista de Conceptos de Entradas/Salidas para combos

  export const apiEliminarPartidaEntradaSalidaInventario =
  serverSubprocess +
  "/TenantMovimientosInventarios/eliminarpartidaentradasalida/{tipo}"; //Funcionalidad para eliminación de partidas en entradas o salidas según el tipo

export const apiEliminarEntradaCompleta =
  serverSubprocess +
  "/TenantMovimientosInventarios/eliminarentrada"; //Funcionalidad para eliminar entrada completa de la base de datos

export const apiEliminarSalidaCompleta =
  serverSubprocess +
  "/TenantMovimientosInventarios/eliminarsalida"; //Funcionalidad para eliminar salida completa de la base de datos

export const apiActualizarCantidadPartidaEntradaSalida =
  serverSubprocess +
  "/TenantMovimientosInventarios/actualizarcantidadpartida"; //Funcionalidad para actualizar cantidad de partida en entradas o salidas
export const apiCancelarEntradaSalida =
  serverSubprocess + "/TenantMovimientosInventarios/cancelarentradasalida/{tipo}"; //Funcionalidad para cancelar una entrada o salida existentes en sistema
export const apiCancelarEntrada =
  serverSubprocess + "/TenantMovimientosInventarios/cancelarentrada"; //Funcionalidad para cancelar una entrada existente en sistema
export const apiCancelarSalida =
  serverSubprocess + "/TenantMovimientosInventarios/cancelarsalida"; //Funcionalidad para cancelar una salida existente en sistema
export const apiStatusEntradaSalida =
  serverSubprocess +
  "/TenantMovimientosInventarios/estatusentradasalida/{folio}/{pc}/{tipo}"; //Funcionalidad para obtener el status de una entrada o salida
export const apiBuscarArticulosEntradas =
  serverSubprocess +
  "/TenantMovimientosInventarios/buscarentradas/{tipo}/{busqueda}/{pc}/{registroinicial}/{totalregistros}"; //Funcionalidad para buscar y obtener lista de entradas/salidas del sistema

export const apiBuscarEntradasAgrupadas =
  serverSubprocess +
  "/TenantMovimientosInventarios/buscarentradasagrupadas/{tipo}/{busqueda}/{pc}/{registroinicial}/{totalregistros}"; //Funcionalidad para buscar y obtener lista de entradas/salidas agrupadas por folio
export const apiFiltroExistenciasAlmacenExhibidor =
  serverSubprocess + "/TenantMovimientosInventarios/existencias"; //Funcionalidad para buscar lista de existencias de almacen o exhibidor del sistema
export const apiFiltroExistenciasFull =
  serverSubprocess + "/TenantMovimientosInventarios/existenciasfull"; //Funcionalidad para buscar existencias consolidadas de todos los almacenes
export const apiExistenciasConCostos =
  serverSubprocess + "/TenantMovimientosInventarios/existenciasconcostos"; //Reporte inventario existente con costos por medida
export const apiGenerarReporteInventario =
  serverSubprocess + "/TenantMovimientosInventarios/reporteinventario/generar"; //Paso 1: genera reporte de inventario y lo guarda en Redis, devuelve jobKey y totales
export const apiIniciarReporteInventario =
  serverSubprocess + "/TenantMovimientosInventarios/reporteinventario/iniciar"; //Paso 1 asíncrono: encola el reporte y devuelve jobKey inmediato
export const apiEstadoReporteInventario =
  serverSubprocess + "/TenantMovimientosInventarios/reporteinventario/estado/{jobkey}"; //Consulta el avance real del reporte en Redis
export const apiKardexArticulos =
  serverSubprocess + "/TenantGeneradorpdf/kardexarticulo/{clavearticulo}/{medida}"; //Funcionalidad para obtener el kardex de un artículo y su medida con respecto al inventario
export const apiTrasladosList = serverSubprocess + "/TenantMovimientosInventarios/traslados/{pc}"; //Funcionalidad para obtener la lista de traslados de la PC
export const apiTrasladosRegistrar =
  serverSubprocess + "/TenantMovimientosInventarios/traslados/registrar"; //Funcionalidad para registrar artículos a traslados por PC
export const apiTrasladosCapturar =
  serverSubprocess + "/TenantMovimientosInventarios/traslados/capturar"; //Consulta, valida y registra una captura de traslado
export const apiTrasladosAplicar =
  serverSubprocess + "/TenantMovimientosInventarios/traslados/aplicartraslado/{pc}"; //Funcionalidad para aplicar traslados al inventario
export const apiTrasladosEliminaPartida =
  serverSubprocess +
  "/TenantMovimientosInventarios/traslados/eliminarpartida/{pc}/{id}"; //Funcionalidad para eliminar partidas de los traslados
export const apiTrasladosEliminaTrasladoPC =
  serverSubprocess + "/TenantMovimientosInventarios/traslados/eliminartraslado/{pc}"; //Funcionalidad para eliminar partidas de los traslados
export const apiBuscarArticuloConExistencia =
  serverSubprocess + "/TenantSubProcess/articuloconexistencias"; //Funcionalidad para buscar artículo por código de barras con existencia actual en almacén
export const apiTrasladosAplicarMasivo =
  serverSubprocess + "/TenantMovimientosInventarios/traslados/aplicarmasivo"; //Funcionalidad para aplicar traslado masivo al inventario
export const apiTrasladosGuardarTemporales =
  serverSubprocess + "/TenantMovimientosInventarios/traslados/guardartemporales"; //Funcionalidad para guardar temporales desde frontend local antes de imprimir/aplicar
export const apiTrasladosCapturarRedis =
  serverSubprocess + "/TenantMovimientosInventarios/traslados/capturar-redis"; //Captura Redis-first con gate de existencia origen
export const apiTrasladosCapturaLista =
  serverSubprocess + "/TenantMovimientosInventarios/traslados/captura-lista/{pc}"; //Mezcla SQL + buffer Redis
export const apiTrasladosValidar =
  serverSubprocess + "/TenantMovimientosInventarios/traslados/validar/{pc}"; //Valida partidas vs existencia para bloqueo de Aplicar
export const apiTrasladosNuevo =
  serverSubprocess + "/TenantMovimientosInventarios/traslados/nuevo"; //Fina, incrementa folio y libera Redis
export const apiLimpiezaNuevo =
  serverSubprocess + "/TenantMovimientosInventarios/limpiezanuevo"; //Limpieza SQL + Redis del folio+PC al dar Nuevo
export const apiTrasladosBuscar =
  serverSubprocess + "/TenantMovimientosInventarios/traslados/buscar/{pc}/{busqueda}"; //Buscador por máquina PE+TR
export const apiTrasladosCapturaEliminarPartida =
  serverSubprocess + "/TenantMovimientosInventarios/traslados/captura-partida/{pc}/{clave}/{medida}/{origen}/{destino}"; //Borrado directo en Redis
export const apiTrasladosCapturaEliminarTodo =
  serverSubprocess + "/TenantMovimientosInventarios/traslados/captura-todo/{pc}"; //Limpia buffer y contexto Redis
export const apiTrasladosCtx =
  serverSubprocess + "/TenantMovimientosInventarios/traslados/ctx/{pc}"; //Contexto origen/destino/folio en Redis
export const apiTrasladosCtxGuardar =
  serverSubprocess + "/TenantMovimientosInventarios/traslados/ctx"; //Guarda contexto en Redis
export const apiMovimientoPrestamo =
  serverSubprocess + "/TenantMovimientosInventarios/prestamos/movimiento";
export const apiSalidasCapturar =
  serverSubprocess + "/TenantMovimientosInventarios/salidas/capturar"; //Consulta, valida y prepara una captura de salida sin escribir por cada lectura
export const apiSalidasGuardarTemporales =
  serverSubprocess + "/TenantMovimientosInventarios/salidas/guardartemporales"; //Guarda en batch las partidas de salida capturadas localmente
export const apiEntradasGuardarTemporales =
  serverSubprocess + "/TenantMovimientosInventarios/entradas/guardartemporales"; //Guarda en batch las partidas de entrada capturadas localmente
export const apiEntradasCatalogoCbarras =
  serverSubprocess + "/TenantMovimientosInventarios/entradas/catalogo-cbarras/{page}/{pageSize}"; //Página del catálogo código->artículo en Redis (carga oculta del lector)
export const apiEntradasResolverCodigo =
  serverSubprocess + "/TenantMovimientosInventarios/entradas/resolver-codigo/{codigo}"; //Read-through Redis->SQL para un código (entradas, sin existencias)
export const apiSalidasResolverCodigo =
  serverSubprocess + "/TenantMovimientosInventarios/salidas/resolver-codigo/{codigo}/{almacen}"; //Read-through con existencia fresca SQL (salidas)
export const apiEntradasCapturar =
  serverSubprocess + "/TenantMovimientosInventarios/entradas/capturar"; //Acumula la partida en el buffer Redis (misma estructura SQL)
export const apiEntradasCapturaLista =
  serverSubprocess + "/TenantMovimientosInventarios/entradas/captura-lista/{tipo}/{folio}/{pc}"; //Mezcla SQL finado + buffer Redis
export const apiEntradasCapturaEliminarPartida =
  serverSubprocess + "/TenantMovimientosInventarios/entradas/captura-partida/{tipo}/{folio}/{pc}/{clave}/{medida}/{almacen}"; //Borrado directo en Redis
export const apiEntradasCapturaEliminarTodo =
  serverSubprocess + "/TenantMovimientosInventarios/entradas/captura-todo/{tipo}/{folio}/{pc}"; //Limpia el buffer Redis del folio+PC
export const apiFolioDisponibleTraslados =
  serverSubprocess + "/TenantMovimientosInventarios/foliotraslado/{pc}"; //Funcionalidad para obtener el folio de traslados disponible por equipo
export const apiImprimirTraslado =
  serverSubprocess + "/TenantMovimientosInventarios/traslados/imprimirtraslado/{pc}"; //Funcionalidad para imprimir el traslado actual registrado
export const apiImprimirTrasladoHistorialDia =
  serverSubprocess + "/TenantMovimientosInventarios/traslados/imprimirhistorialdia"; //OBSOLETO: devuelve 404 recurso no encontrado; conservado solo como fallback
export const apiReporteTrasladosPeriodo =
  serverSubprocess + "/TenantMovimientosInventarios/traslados/reporteperiodo"; //Reporte de traslados por periodo desde SQL/temporales finados, por FechaRegistro (POST con filtros, mismo decorador para no ajustar nginx)
export const apiIngresoRapido =
  serverSubprocess +
  "/TenantMovimientosInventarios/ingresorapido/{clavearticulo}/{medida}/{almacenexhibidor}/{pc}"; //Funcionalidad para dar ingreso rápido a articuos y su medida a un almacen o exhibidor

export const apiSincronizarExistenciasEntradas =
  serverSubprocess + "/TenantMovimientosInventarios/sincronizarentradas";
export const apiSincronizarExistenciasFiltro =
  serverSubprocess + "/TenantMovimientosInventarios/sincronizarfiltro";
export const apiSincronizarExistenciaArticulo =
  serverSubprocess + "/TenantMovimientosInventarios/sincronizararticulo/{clavearticulo}/{medida}/{almacen}";
export const apiValidarStock =
  serverSubprocess + "/TenantMovimientosInventarios/validarstock/{clavearticulo}/{medida}/{almacen}";

export const apiIntegrarEtiquetadoInventario =
  serverSubprocess + "/TenantMovimientosInventarios/etiquetadoentradainventario"; //Funcionalidad para integrar el etiquetado al inventario
export const apiLimpiarEtiquetado = serverSubprocess + "/TenantMovimientosInventarios/etiquetadoclear"; //Funcionalidad para inicializar o finalizar proceso de etiquetado
export const apiUpdateEtiquetado =
  serverSubprocess + "/TenantMovimientosInventarios/etiquetadoupdate"; //Funcionalidad funcionalidar para registrar o actualizar una etiqueta de la lista de etiquetado
export const apiGetListEtiquetado =
  serverSubprocess + "/TenantMovimientosInventarios/etiquetadogetlist"; //Funcionalidad para obtener la lista de etiquetado actual por PC y Almacén/Exhibidor
export const apiReporteEtiquetadoDiario =
  serverSubprocess +
  "/TenantMovimientosInventario/reporteetiquetadodiario/{pc}/{almacenexhibidor}"; //Funcionalidad para obtener e reporte de PDF del etiquetado diario realizado
export const apiAgregarEtiquetado =
  serverSubprocess + "/TenantMovimientosInventarios/etiquetadoagregar"; //Funcionalidad para agregar artículos al proceso de etiquetado
export const apiEliminarPartidaEtiquetado =
  serverSubprocess + "/TenantMovimientosInventarios/etiquetadodeletepartida"; //Funcionalidad para eliminar partida completa de etiquetado
export const apiCambiarAlmacenEtiquetado =
  serverSubprocess + "/TenantMovimientosInventarios/etiquetadocambiaralmacen"; //Funcionalidad para cambiar almacén de todos los registros de etiquetado por PC


//Toma Inventarios

export const apiTomaInventarioActivo =
  serverTomaInventarios + "/TenantTomaInventarios/toma/activo";
export const apiTomaInventarioCrearFolio =
  serverTomaInventarios + "/TenantTomaInventarios/toma/crear";
export const apiTomaInventarioGetHeader =
  serverTomaInventarios + "/TenantTomaInventarios/toma/{folioinventario}/header";
export const apiTomaInventarioGetDetalle =
  serverTomaInventarios + "/TenantTomaInventarios/toma/{folioinventario}/detalles";
export const apiTomaInventarioGetDetallePaginados =
  serverTomaInventarios +
  "/TenantTomaInventarios/toma/{folioinventario}/detalles/paginados";
export const apiTomaInventarioAgregarArticulo =
  serverTomaInventarios + "/TenantTomaInventarios/toma/agregararticulo";
export const apiTomaInventarioImportarConteos =
  serverTomaInventarios +
  "/TenantTomaInventarios/toma/{folioinventario}/importarconteos";
export const apiTomaInventarioValidarZonas =
  serverTomaInventarios +
  "/TenantTomaInventarios/toma/{folioinventario}/validarconteos";

export const apiTomaInventarioSaveHeader =
  serverTomaInventarios + "/TenantTomaInventarios/toma/{folioinventario}/saveheader";
export const apiTomaInventarioSaveDetalle =
  serverTomaInventarios +
  "/TenantTomaInventarios/toma/{folioinventario}/savedetalles";
export const apiTomaInventarioCargarGeneral =
  serverTomaInventarios +
  "/TenantTomaInventarios/toma/{folioinventario}/cargar-general";
export const apiBuscarArticulosInventario =
  serverTomaInventarios + "/TenantTomaInventarios/conteosescaneo/buscararticuloporcodigobarrastomainventarios/{folioinventario}/{codigobarras}";

export const apiTomaInventarioFijarConteo =
  serverTomaInventarios +
  "/TenantTomaInventarios/toma/{folioinventario}/fijar-conteo";
export const apiTomaInventarioCerrar =
  serverTomaInventarios + "/TenantTomaInventarios/toma/{folioinventario}/cerrar";
export const apiTomaInventarioAplicar =
  serverTomaInventarios + "/TenantTomaInventarios/toma/{folioinventario}/aplicar";
export const apiTomaInventarioCancelar =
  serverTomaInventarios + "/TenantTomaInventarios/toma/{folioinventario}/cancelar";
export const apiTomaInventarioLiberar =
  serverTomaInventarios + "/TenantTomaInventarios/toma/{folioinventario}/liberar";
export const apiTomaInventarioPdf =
  serverTomaInventarios + "/TenantTomaInventarios/toma/{folioinventario}/pdf";
export const apiTomaInventarioActualizarConteoAFijar =
  serverTomaInventarios +
  "/TenantTomaInventarios/toma/{folioinventario}/detalle/fijar";
export const apiTomaInventarioSumarConteo1YFijar =
  serverTomaInventarios +
  "/TenantTomaInventarios/toma/{folioinventario}/detalle/conteo1/sumar-fijar";

// Nuevas APIs para eliminar
export const apiTomaInventarioEliminarArticulo =
  serverTomaInventarios +
  "/TenantTomaInventarios/toma/{folioinventario}/detalle/eliminar";
export const apiTomaInventarioEliminarTodo =
  serverTomaInventarios +
  "/TenantTomaInventarios/toma/{folioinventario}/detalle/eliminar-todo";
export const apiTomaInventarioFijarTodoConteo =
  serverTomaInventarios +
  "/TenantTomaInventarios/toma/{folioinventario}/fijar-todo/{conteoNumero}";
export const apiTomaInventarioReiniciarConteos =
  serverTomaInventarios +
  "/TenantTomaInventarios/toma/{folioinventario}/reiniciar-conteos";
export const apiTomaInventarioBuscarDetalle =
  serverTomaInventarios +
  "/TenantTomaInventarios/toma/{folioinventario}/detalles/buscar";
export const apiTomaInventarioBuscarArticulos =
  serverTomaInventarios + "/TenantTomaInventarios/toma/buscar-por-articulo";
export const apiTomaInventarioReiniciarConteoArticulo =
  serverTomaInventarios +
  "/TenantTomaInventarios/toma/{folioinventario}/reiniciar-conteo-articulo";
export const apiTomaInventarioEditarConteo3 =
  serverTomaInventarios +
  "/TenantTomaInventarios/toma/{folioinventario}/editar-conteo3";
export const apiTomaInventarioEliminarConteosEscaneo =
  serverTomaInventarios +
  "/TenantTomaInventarios/toma/{folioinventario}/eliminar-conteos-escaneo";
export const apiTomaInventarioImportarConteosAConteosEscaneo =
  serverTomaInventarios +
  "/TenantTomaInventarios/toma/{folioinventario}/importar-conteos-a-escaneos";
export const apiTomaInventarioZonasArticulo =
  serverTomaInventarios + "/TenantTomaInventarios/toma/zonas-articulo/{claveArticulo}";

// Conteos Escaneo (escaneo de conteos 1, 2, 3 por zona/almacen)
export const apiConteosEscaneoCrear =
  serverTomaInventarios + "/TenantTomaInventarios/conteosescaneo/crear";
export const apiConteosEscaneoCrearLote =
  serverTomaInventarios + "/TenantTomaInventarios/conteosescaneo/crear-lote";
export const apiConteosEscaneoCatalogoInventario =
  serverTomaInventarios + "/TenantTomaInventarios/conteosescaneo/catalogo/{folioinventario}";
export const apiConteosEscaneoListar =
  serverTomaInventarios + "/TenantTomaInventarios/conteosescaneo/listar";
export const apiConteosEscaneoZonas =
  serverTomaInventarios + "/TenantTomaInventarios/conteosescaneo/zonas/{folioinventario}";
export const apiConteosEscaneoEliminar =
  serverTomaInventarios + "/TenantTomaInventarios/conteosescaneo/eliminar/{pk}";
export const apiConteosEscaneoAbrir =
  serverTomaInventarios + "/TenantTomaInventarios/conteosescaneo/abrir";
export const apiConteosEscaneoCerrar =
  serverTomaInventarios + "/TenantTomaInventarios/conteosescaneo/cerrar";
export const apiConteosEscaneoReiniciar =
  serverTomaInventarios + "/TenantTomaInventarios/conteosescaneo/reiniciar";
export const apiConteosEscaneoEstado =
  serverTomaInventarios + "/TenantTomaInventarios/conteosescaneo/estado";
export const apiConteosEscaneoStats =
  serverTomaInventarios + "/TenantTomaInventarios/conteosescaneo/stats";
export const apiConteosEscaneoSend =
  serverTomaInventarios + "/TenantTomaInventarios/conteosescaneo/send";
export const apiConteosEscaneoDisponible =
  serverTomaInventarios + "/TenantTomaInventarios/conteosescaneo/disponible";
export const apiConteosEscaneoEliminarConteoCompleto =
  serverTomaInventarios + "/TenantTomaInventarios/conteosescaneo/eliminar-conteo-completo";

//Subsprocess utils
export const apiClientesList =
  serverCatalogos + "/TenantCatalogoClientes/clienteslist"; //Funcionalidad para obtener la lista completa de clientes del sistema
export const apiClientesByNombre =
  serverCatalogos + "/TenantCatalogoClientes/clientesbynombre/{nombre}"; //Funcionalidad para buscar clientes por nombre o razón social (buscador)
export const apiClientesByClave =
  serverCatalogos + "/TenantCatalogoClientes/clientesbyclave/{clave}"; //Funcionalidad para obtener datos de un cliente por su clave
export const apiClientesBusquedaFiltro =
  serverCatalogos + "/TenantCatalogoClientes/clientesfiltro/{busqueda}/{registroinicial}/{totalregistros}"; //Búsqueda paginada de clientes
export const apiClientePorcentajeDescuento =
  serverCatalogos + "/TenantCatalogoClientes/porcentajedescuento/{clave}"; //Funcionalidad para obtener el porcentaje de descuento de un cliente
export const apiClienteSave = serverCatalogos + "/TenantCatalogoClientes/clientesave"; //Funcionalidad para guardar o actualizar un cliente
export const apiClienteDelete =
  serverCatalogos + "/TenantCatalogoClientes/clientedelete/{razonsocial}"; //Funcionalidad para eliminar un cliente del sistema
export const apiClienteAsignarTarjeta =
  serverCatalogos + "/TenantCatalogoClientes/asignartarjeta"; //Funcionalidad para asignar una tarjeta (código de barras) a un cliente

export const apiClientePrefijoClave =
  serverCatalogos + "/TenantCatalogoClientes/prefijoclavecliente"; //Funcionalidad para consultar y guardar el prefijo de claves de cliente

//Apis MovilApp
export const apiClienteAppActivationQrCreate = serverClientesMoviles + "/TenantAppClientes/crearqractivacion";

export const apiMontoEnLetra =
  serverSubprocess + "/TenantSubProcess/montoenletra/{monto}"; //Se usa para terminar el proceso de vena y desgloses de inventarios

//Reportes
export const apiObtenerReporteEntradasSalidas =
  serverSubprocess + "/TenantGeneradorpdf/reporteentradassalidas"; //Se usa para obtener el reporte en pdf de las entradas o salidas

//Caja - Apertura/Cierre/Retiro
export const apiAperturaCaja =
  serverSubprocess + "/TenantAdministracion/aperturacaja";
export const apiStatusCaja =
  serverSubprocess + "/TenantAdministracion/statuscaja/{caja}";
export const apiCierreCaja = serverSubprocess + "/TenantAdministracion/cierrecaja";
export const apiRetiroCapital =
  serverSubprocess + "/TenantAdministracion/retirocapital";
export const apiBuscarAperturas =
  serverSubprocess + "/TenantAdministracion/buscaraperturas/{caja}";
export const apiBuscarCierres =
  serverSubprocess + "/TenantAdministracion/buscarcierres/{caja}";
export const apiBuscarRetiros =
  serverSubprocess + "/TenantAdministracion/buscarretiros/{caja}";

//Reportes
export const apiReporteCorteGeneralSucursal =
  serverSubprocess + "/TenantGeneradorpdf/reportecortesucursal";
export const apiReporteCorteGeneralSucursalTicket =
  serverSubprocess + "/TenantGeneradorpdf/reportecortesucursalticket"; //Consolidado sucursal con estructura del ticket de cierre
export const apiReporte8020 = serverSubprocess + "/TenantGeneradorpdf/reporte8020";
export const apiReporte8020Agrupado = serverSubprocess + "/TenantGeneradorpdf/reporte8020agrupado";
export const apiReporte8020MarcaModelo = serverSubprocess + "/TenantGeneradorpdf/reporte8020marcamodelo";
export const apiReporteCorteDetalladoCaja =
  serverSubprocess + "/TenantGeneradorpdf/reportecortedetallado";
export const apiReporteComisiones =
  serverSubprocess + "/TenantGeneradorpdf/reportecomisiones";
export const apiReporteResumenVentasPeriodo =
  serverSubprocess + "/TenantGeneradorpdf/reporteresumenventasperiodo";
export const apiReporteInventarioExistente =
  serverSubprocess + "/TenantGeneradorpdf/reporteinventarioexistente";
export const apiReporteInventarioExistenteDesdeRedis =
  serverSubprocess + "/TenantGeneradorpdf/reporteinventarioexistente-desde-redis"; //Paso 2: PDF del reporte leído de Redis por jobKey
export const apiReporteEntradasSalidasPeriodo =
  serverSubprocess + "/TenantGeneradorpdf/reporteentradassalidasperiodo";
export const apiPrevendedoresComision = serverSubprocess + "/TenantAdministracion/prevendedorescomision";
export const apiComisionesVenta = serverSubprocess + "/TenantAdministracion/comisionesventa";
export const apiResumenTotalesCaja = serverSubprocess + "/TenantAdministracion/resumentotalescaja/{fechaventa}/{pc}/{vendedor}";
export const apiResumenVentasPeriodo =
  serverSubprocess + "/TenantAdministracion/resumenventasperiodo";


// AI Intelligence
export const apiIAAgragarVector = serverIA + "/TenantIAArticulos/agregarvector";
export const apiIAInfoAprendizaje = serverIA + "/TenantIAArticulos/infoaprendizaje/{claveArticulo?}";
export const apiIAConsultarArticulos = serverIA + "/TenantIAArticulos/articulos/{almacen}";
export const apiIAEliminarEntrenamiento = serverIA + "/TenantIAArticulos/eliminarentrenamiento/{claveArticulo}";
export const apiIAExportarModelo = serverIA + "/TenantIAArticulos/exportarmodelo";
export const apiIAImportarModelo = serverIA + "/TenantIAArticulos/importarmodelo";
export const apiIAPredecir = serverIA + "/TenantIAArticulos/predecir";
export const apiIASincronizarTodo = serverIA + "/TenantIAArticulos/sincronizartodo";
export const apiIAArticuloPorClave = serverIA + "/TenantIAArticulos/articulo/{clavearticulo}";
export const apiIAGuardarImagen = serverIA + "/TenantIAArticulos/guardarimagen";
export const apiIADebug = serverIA + "/TenantIAArticulos/debug";
export const apiIAEntrenarModelo = serverIA + "/TenantIAArticulos/entrenar-modelo";
export const apiIAEntrenarEstado = serverIA + "/TenantIAArticulos/entrenar-estado/{jobId}";
export const apiIAMetricas = serverIA + "/TenantIAArticulos/metricas/{dominio?}";
export const apiIATiposCalzadoAgregarVector = serverIA + "/TenantIATiposCalzado/agregarvector";
export const apiIATiposCalzadoInfoAprendizaje = serverIA + "/TenantIATiposCalzado/infoaprendizaje/{tipoCalzado?}";
export const apiIATiposCalzadoPredecir = serverIA + "/TenantIATiposCalzado/predecir";
export const apiIATiposCalzadoEliminarEntrenamiento = serverIA + "/TenantIATiposCalzado/eliminarentrenamiento/{tipoCalzado}";

//Centro de Costos
export const apiCentroCostosCorridas = serverCentroCostos + "/TenantCentroCostos/corridas";
export const apiCentroCostosArticulos = serverCentroCostos + "/TenantCentroCostos/articulos";
export const apiCentroCostosActualizarCostos = serverCentroCostos + "/TenantCentroCostos/actualizarcostos";
export const apiCentroCostosAplicarOferta = serverCentroCostos + "/TenantCentroCostos/aplicaroferta";
export const apiCentroCostosEliminarOferta = serverCentroCostos + "/TenantCentroCostos/eliminaroferta";
export const apiCentroCostosEliminarOfertaFechas = serverCentroCostos + "/TenantCentroCostos/eliminar-ofertas-fechas";
export const apiCentroCostosOfertas = serverCentroCostos + "/TenantCentroCostos/ofertas";

// Compras
export const apiFolioCompra = serverCentroCostos + "/TenantCompras/nuevo/folio/{pc}";
export const apiRegistrarCabeceroCompra = serverCentroCostos + "/TenantCompras/cabecero";
export const apiRegistrarDetalleCompra = serverCentroCostos + "/TenantCompras/detalle";
export const apiObtenerCompra = serverCentroCostos + "/TenantCompras/obtener/{folio}/{pc}";
export const apiActualizarDetalleCompra = serverCentroCostos + "/TenantCompras/detalle/cantidad";
export const apiActualizarCorridaDetalleCompra = serverCentroCostos + "/TenantCompras/detalle/corrida";
export const apiObtenerDatosMedida = serverCentroCostos + "/TenantCompras/datos/corrida/{clavearticulo}/{corrida}";
export const apiEliminarPartidaCompra = serverCentroCostos + "/TenantCompras/partida/eliminar/{folio}/{pc}/{clave}/{corrida}";
export const apiMontoALetra = serverCentroCostos + "/TenantCompras/montoaletra/{monto}";
export const apiEliminarCompraCompleta = serverCentroCostos + "/TenantCompras/eliminar/{folio}/{pc}";
export const apiAplicarCompra = serverCentroCostos + "/TenantCompras/aplicar/{folio}/{pc}";
export const apiListaProveedores = serverCentroCostos + "/TenantCompras/proveedores/lista";
export const apiProveedoresArticulos = serverCentroCostos + "/TenantCompras/proveedores/articulos/{proveedor}";
export const apiReporteCompra = serverCentroCostos + "/TenantCompras/reporte/generar/{folio}/{pc}";
export const apiBuscarCompras = serverCentroCostos + "/TenantCompras/buscar/{busqueda}";
export const apiArticulosSimple = serverCentroCostos + "/TenantCompras/articulos/{filtro}";
export const apiMedidasCorrida = serverCentroCostos + "/TenantCompras/medidas/corrida/{clavearticulo}/{corrida}";
export const apiMedidasGuardadas = serverCentroCostos + "/TenantCompras/medidas/partida/{folio}/{pc}/{clave}/{corrida}";
export const apiGuardarMedidas = serverCentroCostos + "/TenantCompras/medidas/guardar/{folio}/{pc}/{clave}/{corrida}";
// Cuentas por Pagar
export const apiCuentasXPagarListar = serverCentroCostos + "/TenantCuentasXPagar/listar";
export const apiCuentasXPagarEstado = serverCentroCostos + "/TenantCuentasXPagar/estado/{claveproveedor}/{foliocompra}";
export const apiCuentasXPagarRegistrarAbono = serverCentroCostos + "/TenantCuentasXPagar/abonos/registrar";
export const apiCuentasXPagarAbono = serverCentroCostos + "/TenantCuentasXPagar/abonos/{folioabono}";

// Catálogo Proveedores
export const apiProveedoresList = serverCatalogos + "/TenantCatalogoProveedores/proveedoreslist";
export const apiProveedoresByNombre = serverCatalogos + "/TenantCatalogoProveedores/proveedoresbynombre/{nombre}";
export const apiProveedoresByClave = serverCatalogos + "/TenantCatalogoProveedores/proveedoresbyclave/{clave}";
export const apiProveedoresSave = serverCatalogos + "/TenantCatalogoProveedores/proveedoresave";
export const apiProveedoresDelete = serverCatalogos + "/TenantCatalogoProveedores/proveedordelete/{razonsocial}";
export const apiProveedoresFiltro = serverCatalogos + "/TenantCatalogoProveedores/proveedoresfiltro/{busqueda}/{registroinicial}/{totalregistros}";

// Control de asistencias
export const apiTiemposUsuarios = serverAdministrativo + "/TenantTiempos/usuarios";
export const apiTiemposHoy = serverAdministrativo + "/TenantTiempos/hoy/{usuario}";
export const apiTiemposRango = serverAdministrativo + "/TenantTiempos/rango/{usuario}/{fechainicio}/{fechafin}";
export const apiTiemposRegistrar = serverAdministrativo + "/TenantTiempos/registrar";
export const apiTiemposUltimaLectura = serverAdministrativo + "/TenantTiempos/lecturas/ultima";

// Nóminas
export const apiNominasUsuarios = serverAdministrativo + "/TenantNominas/usuarios";
export const apiNominasComisiones = serverAdministrativo + "/TenantNominas/comisiones";
export const apiNominasFolio = serverAdministrativo + "/TenantNominas/folio";
export const apiNominasGuardar = serverAdministrativo + "/TenantNominas/guardar";
export const apiNominasAplicar = serverAdministrativo + "/TenantNominas/aplicar";
export const apiNominasHistorial = serverAdministrativo + "/TenantNominas/historial";
  export const apiNominasHistorialDetalle = serverAdministrativo + "/TenantNominas/historial/{id}";
  export const apiNominasParametros = serverAdministrativo + "/TenantNominas/parametros";
export const apiReporteNomina = serverAdministrativo + "/TenantGenerador/reportenomina";
export const apiNominasEliminar = serverAdministrativo + "/TenantNominas/eliminar";
export const apiConsultarFolioVale = serverSubprocess + "/TenantVentas/valesporecambio/nextfolio"; //Funcionalidad para obtener el siguiente folio disponible de un vale por cambio
export const apiGenerarValePorCambio = serverSubprocess + "/TenantVentas/generarvaleporcambio"; //Funcionalidad para generar un vale por cambio
export const apiObtenerValePorCambio = serverSubprocess + "/TenantVentas/valesporcambio/{folio}"; //Funcionalidad para consultar un vale por cambio por folio (backend valida status/caducidad, front solo muestra veredicto)
export const apiPrestamosRegistrar = serverAdministrativo + "/TenantPrestamos/registrar";
export const apiPrestamosRegistrarAbono = serverAdministrativo + "/TenantPrestamos/registrarabono";
export const apiPrestamosEstadoCuenta = serverAdministrativo + "/TenantPrestamos/estadocuenta/{usuarioempleado}";
export const apiPrestamosList = serverAdministrativo + "/TenantPrestamos/list";
export const apiPrestamosDeduccionesNomina = serverAdministrativo + "/TenantPrestamos/deduccionesnomina";
export const apiPrestamosBonos = serverAdministrativo + "/TenantPrestamos/bonos";
export const apiPrestamosBonosGuardar = serverAdministrativo + "/TenantPrestamos/bonos/guardar";

// Sincronizacion segura entre tiendas tenant.
export const apiTenantSyncRelations = serverSubprocess + "/TenantSubProcess/sync/relations";
export const apiTenantSyncJobs = serverSubprocess + "/TenantSubProcess/sync/jobs";

// WhatsApp
export const apiWhatsAppEnviar = serverSubprocess + "/TenantWhatsApp/enviar";
export const apiWhatsAppContactoGuardar = serverSubprocess + "/TenantWhatsApp/contacto/guardar";



